import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { Col, Form, Row } from 'react-bootstrap';
import StudentCombo from '../combos/StudentCombo';
import SchoolClassCombo from '../combos/SchoolClassCombo';
import PrintGradeSheet from './PrintGradeSheet';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PrintGradeSheetDescriptional from './PrintGradeSheetDescriptional';
import PrintDisiplineSheet from './PrintDisiplineSheet';
import ShowVideo from '../shared/ShowVideo';



export default function SchoolGradeSheetPrint(props) {
    const toast = useRef(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [student, setStudent] = useState(null);
    const [schoolClass, setSchoolClass] = useState(null);
    const [linkVisible, setLinkVisible] = useState(false); 
    const [pdfFileIsReady, setPdfFileIsReady] = useState(false);
    const [gradeSheetType, setGradeSheetType] = useState(0);
          
    const [gradeSheets, setGradeSheets] = useState([]);

    useEffect(() => {
    }, []);

    const printGradeSheet = function(studentId, schoolClassId, type){
      if(type == 3){
        var url = config.Client + "/school/disipline/grade-sheet/print";
        url += "?studentId=" + studentId;
        url += "&schoolClassId=" + schoolClassId;
        window.open(url);
        return;
      }
      setLinkVisible(true);
      setPdfFileIsReady(false);
      setGradeSheetType(type);
      var params = {login:util.getTrustedUser(), schoolClassId:schoolClassId, studentId:studentId, sheetType:type};
      var url = config.Server+`/school/month/grade-sheet/get`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log(response);
                  var gss = response;
                  if(type == 1){
                    for(var g=0;g<gss.length;g++){
                      for(var c=gss[g].courses.length-1;c>=0;c--){
                        var found = false;
                        for(var i=0;i<gss[g].courses[c].scores.length;i++){
                          if(gss[g].courses[c].scores[i].isValid){
                            found = true;
                            break;
                          }
                        }
                        if(!found){
                          gss[g].courses.splice(c, 1);
                        }
                      }
                    }
                    var max = 18;
                    for(var i=0;i<gss.length;i++){
                      gss[i]["emptyRows"] = [];
                      console.log("(i, len)->" + "(" + i + ", " + gss[i].courses.length + ")");
                      if(gss[i].courses.length < max) {
                        var rem = max-gss[i].courses.length;
                        console.log("(i, rem)->" + "(" + i + ", " + rem + ")");
                        gss[i]["emptyRows"] = Array.from({length:(rem)});
                      }
                    }
                  }
                  //gss[0].items = [];
                  for(i=25;i>=18;i--){
                    //gss[0].items.splice(i, 1);
                  }
                  console.log("grade sheets is> ", gss);
                  setGradeSheets(gss);
                  //setGradeSheets([]);
                  setPdfFileIsReady(true);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setLinkVisible(false);
                  if(props.onComplete) props.onComplete(false, response.message);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setLinkVisible(false);
              if(props.onComplete) props.onComplete(false, error.code + "," + error.message);
          });

    }
  
    return(      
      <>
      <ShowVideo videoId="create_print_gradesheet" top={65} md={6} /> 
        <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>چاپ کارنامه</div>
        <div className="" style={{ width:"calc(100% - 0px)"}}>
          <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
              <Row>
                <Col md={3}>
                  <StudentCombo value={student} onChange={(value)=>{ setStudent(value.itemValue); setLinkVisible(false);}}  returnFullItem={true}/>
                </Col>
              </Row>
              <Row style={{marginTop:"10px", paddingBottom:"10px"}}>
                <Col md={3}>
                  <Button disabled={(!student)||(student == null)} icon="pi pi-print" label='چاپ کارنامه دانش آموز' saving={loading} rounded severity="primary" style={{width:"300px", margin: "10px 3px", float:"right" }} onClick={() => {printGradeSheet(student.id, "", 1)}} />
                </Col>
                <Col md={3}>
                  <Button disabled={(!student)||(student == null)} icon="pi pi-print" label='چاپ کارنامه توصیفی' saving={loading} rounded severity="primary" style={{width:"300px", margin: "10px 3px", float:"right" }} onClick={() => {printGradeSheet(student.id, "", 2)}} />
                </Col>
                <Col md={3}>
                  <Button disabled={(!student)||(student == null)} icon="pi pi-print" label='چاپ کارنامه تربیتی' saving={loading} rounded severity="primary" style={{width:"300px", margin: "10px 3px", float:"right" }} onClick={() => {printGradeSheet(student.id, "", 3)}} />
                </Col>
              </Row>
          </div>
        </div>

        <div className="" style={{ width:"calc(100% - 0px)", marginTop:"50px"}}>
          <div style={{backgroundColor:'rgb(238, 255, 233)', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
              <Row>
                <Col md={3}>
                  <SchoolClassCombo returnFullItem={true} value={schoolClass} onChange={(val) => {setSchoolClass(val); setLinkVisible(false);}} />
                </Col>
              </Row>
              <Row style={{marginTop:"10px", paddingBottom:"10px"}}>
                <Col md={3}>
                  <Button  disabled={!((schoolClass)&&(schoolClass.id)&&(schoolClass.id != ""))} icon="pi pi-print" label='چاپ کارنامه دانش آموزان' saving={loading} rounded severity="success" style={{width:"300px", margin: "10px 3px", float:"right" }} onClick={() => {printGradeSheet("", schoolClass.id, 1)}} />
                </Col>
                <Col md={3}>
                  <Button  disabled={!((schoolClass)&&(schoolClass.id)&&(schoolClass.id != "")&&(schoolClass.itemValue.degree>=1)&&(schoolClass.itemValue.degree<=6))} icon="pi pi-print" label='چاپ کارنامه های توصیفی' saving={loading} rounded severity="success" style={{width:"300px", margin: "10px 3px", float:"right" }} onClick={() => {printGradeSheet("", schoolClass.id, 2)}} />
                </Col>
                <Col md={3}>
                  <Button  disabled={!((schoolClass)&&(schoolClass.id)&&(schoolClass.id != ""))} icon="pi pi-print" label='چاپ کارنامه های تربیتی' saving={loading} rounded severity="success" style={{width:"300px", margin: "10px 3px", float:"right" }} onClick={() => {printGradeSheet("", schoolClass.id, 3)}} />
                </Col>
              </Row>
          </div>
        </div>

        {
          linkVisible?
          <div className="" style={{ width:"calc(100% - 0px)", marginTop:"50px"}}>
            <div style={{backgroundColor:'rgba(255, 254, 211, 1)', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
                <Row>
                  <Col md={3}>
                    لینک دانلود کارنامه:
                  </Col>
                </Row>
                <Row style={{marginTop:"10px", paddingBottom:"10px"}}>
                  {
                    gradeSheetType == 1?
                    <Col md={3}>
                      {
                        pdfFileIsReady?
                        <PDFDownloadLink  style={{textDecoration:"0px"}}
                          document={<PrintGradeSheet 
                            data={gradeSheets} 
                            />} fileName={"Karname_"+util.generateRandomUString(10)+".pdf"}>
                              <label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود کارنامه!</label>
                          {
                            // ({ blob, url, loading, error }) =>
                            // loading ? 'درحال آماده سازی فایل...' : <><label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود برنامه هفتگی!</label></>
                          }
                        </PDFDownloadLink>
                        :
                        <>درحال آماده سازی فایل...</>
                      }
                      
                    </Col>
                    :
                    <></>
                  }
                  {
                    gradeSheetType == 2?
                    <Col md={3}>
                      {
                        pdfFileIsReady?
                        <PDFDownloadLink  style={{textDecoration:"0px"}}
                          document={<PrintGradeSheetDescriptional 
                            data={gradeSheets} 
                            />} fileName={"Karname_decriptional_"+util.generateRandomUString(10)+".pdf"}>
                              <label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود کارنامه توصیفی!</label>
                          {
                            // ({ blob, url, loading, error }) =>
                            // loading ? 'درحال آماده سازی فایل...' : <><label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود برنامه هفتگی!</label></>
                          }
                        </PDFDownloadLink>
                        :
                        <>درحال آماده سازی فایل توصیفی...</>
                      }
                      
                    </Col>
                    :
                    <></>
                  }
                  {
                    gradeSheetType == 3?
                    <Col md={3}>
                      {
                        pdfFileIsReady?
                        <PDFDownloadLink  style={{textDecoration:"0px"}}
                          document={<PrintDisiplineSheet 
                            data={gradeSheets} 
                            />} fileName={"Karname_decriptional_"+util.generateRandomUString(10)+".pdf"}>
                              <label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود کارنامه تربیتی!</label>
                          {
                            // ({ blob, url, loading, error }) =>
                            // loading ? 'درحال آماده سازی فایل...' : <><label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود برنامه هفتگی!</label></>
                          }
                        </PDFDownloadLink>
                        :
                        <>درحال آماده سازی فایل تربیتی...</>
                      }
                      
                    </Col>
                    :
                    <></>
                  }
                </Row>
            </div>
          </div>
          :<></>
        }

          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
          <Toast ref={toast} />            
      </>  
    );
  
}
